<template>
    <div class="product-grid-wrap" >
        <div class="mb-3 row"  >
            <div class="col-sm-12 ButtomTop" v-if="showEmptyCompanyState">
                <div  v-if="fromAdmin" > {{ $t("lbl_EMPBE_NotHaveProduct") }}</div>
                <b-button v-else class="btn btn-outline-primary p-l-15 d-flex align-items-center" variant="outline-primary"
                    @click="checkLaunchLimit" v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnAddNew'">
                    <feather type="plus-circle"> </feather>
                    {{ $t("lbl_EMPBE_NotHaveProduct") }}
                </b-button>
                
            </div>
        </div>
        <b-overlay  :show="loading" rounded="sm" v-if="!showEmptyCompanyState">
            <span class="export-buttons" v-if="!fromAdmin">
                <kbutton :theme-color="'secondary'" @click="checkLaunchLimit"
                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnAddNew'">
                    <i class="fa fa-plus-circle" style="line-height: 1.5;"></i>
                    {{ $t("lbl_EMPBE_ProductInfo_ProductGrid_AddProduct") }}
                </kbutton>
                &nbsp;
                <kbutton :theme-color="'secondary'" @click="openMembershipInfoPage"
                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnAddToCart'"
                    :disabled="otherInfo ? otherInfo.product_TotalQty >= 50 : false">
                    <i class="fa fa-info-circle" style="line-height: 1.5;"></i>
                    {{ $t("lbl_EMPBE_ProductInfo_ProductGrid_AddProductMoreQuota", {
                        totalNumberOfProducts:(otherInfo ? otherInfo.product_OccupiedCount : 0), MaxQuota: (otherInfo ? otherInfo.product_TotalQty : 0)}) }}
                    <!-- 产品的（已上架数量/份额总数） {{ $t("lbl_EMPBE_ProductInfo_ProductGrid_AddProductMoreQuota",{totalNumberOfProducts:(otherInfo ? otherInfo.product_LaunchedCount : 0),MaxQuota:(otherInfo ? otherInfo.product_TotalQty : 0)}) }} -->
                </kbutton>
            </span>
            <localization :language="kendoLang">
                <intl  :locale="kendoLang">

                    <!-- Same structure as AdListView: shell (scroll) > min-width content -->
                    <div class="product-grid-table-shell">
                    <div
                        class="product-grid-table-min"
                        :class="{ 'product-grid-table-min--admin': fromAdmin }"
                    >
                    <Grid  id="product-prod-grid" :class="{ 'product-grid--admin': fromAdmin }" ref="grid" :data-items="gridData" :resizable="true" :reorderable="true" :sortable="true"
                        :pageable="gridPageable" :groupable="false" :group="group" :sort="sort" :filter="filter"
                        :take="take" :skip="skip" :columns="columns" :column-menu="columnMenu" :selectable="true"
                        :filterable="true" :selected-field="selectedField"
                        @headerselectionchange="onHeaderSelectionChange" @filterchange="filterChange"
                        @datastatechange="dataStateChange" @selectionchange="onSelectionChange"
                        :filter-cell-render="filterRender" @rowclick="onRowClick" >
                        <template v-slot:productNameHeaderTemplate="{ props }">
                            <div v-if="!fromAdmin && selectedDataItems.length" class="product-bulk-bar" @click.stop>
                                <span class="product-bulk-bar__count">
                                    {{ $t('lbl_EMPBE_ProductInfo_BulkSelected', { count: selectedDataItems.length }) }}
                                </span>
                                <button type="button" class="product-bulk-bar__delist"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnBulkDelist'"
                                    :disabled="bulkBusy"
                                    @click.stop="delistSelected">
                                    {{ $t('lbl_EMPBE_ProductInfo_Delist') }}
                                </button>
                                <button type="button" class="product-bulk-bar__delete"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnBulkDelete'"
                                    :disabled="bulkBusy"
                                    @click.stop="askDeleteSelected">
                                    {{ $t('lbl_EMPBE_Delete') }}
                                </button>
                            </div>
                            <span v-else>{{ props.title }}</span>
                        </template>
                        <template v-slot:productIdColumnTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'" class="product-id-cell">
                                {{ props.dataItem.productId }}
                            </td>
                        </template>
                        <template v-slot:productIdFilterSlotTemplate="{ props, methods }">
                            <div>
                                <k-input
                                    :placeholder="$t('lbl_EMPBE_ProductInfo_ProductGrid_ProductId_Filter')"
                                    :value="serverProductId"
                                    @input="(ev) => {
                                        serverProductId = ev.target.value.replace(/[^0-9]/g, '');
                                        skip = 0;
                                        debounceServerFetch();
                                    }"
                                />
                            </div>
                        </template>
                        <template v-slot:productIdTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'" class="product-name-cell">
                                <div class="pl-0 Goto-ProductDetail fontcolor"
                                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_' + props.dataItem.productId">
                                    <div class="product-name-row d-flex align-items-center">
                                      <span class="product-image-conver">
                                            <img :src="`${props.dataItem.imgFileUrl}`" /> 
                                        </span>
                                            <span class="textlengthdrop">                                            
                                              {{ props.dataItem.name }}
                                            </span>
                                        <span
                                            v-if="hasRowDraftIndicator(props.dataItem)"
                                            class="product-list-draft-pill"
                                            role="status"
                                        >
                                            <svg class="product-list-draft-pill__icon" width="14" height="16" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                              <path d="M4 11H12V9H4V11ZM4 14H12V12H4V14ZM4 17H9V15H4V17ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z" fill="#5D5125"/>
                                            </svg>
                                            {{ $t('lbl_EMPBE_Draft') }}
                                        </span>
                                        <a
                                            href="javascript:void(0)"
                                            class="text-default edit-badge Goto-ProductDetail-edit"
                                            @click="goProductDetail(props.dataItem.productId, $event)"
                                        ><img
                                                class="textlengthdrop-img" src="../../assets/images/edit.svg" />{{
                                            $t("lbl_EMPBE_edit") }}</a>
                                    </div>
                                </div>
                            </td>
                        </template>
                        <template v-slot:isFireTemplate="{ props }">
                            <!-- <td v-if="props.rowType !== 'groupHeader'">
                                <span class="badge badge-light-info m-r-5 m-l-5 f-16" v-if="props.dataItem.isFire" :onclick="handleclick(props.dataItem.id)">
                                    <i class="icofont icofont-fire-alt f-16 mr-0"></i>
                                    {{ $t('lbl_EMPBE_MainProd') }}
                                </span>
                                <span v-else class="badge-light badge m-r-5 m-l-5 f-16" :onclick="handleclick(props.dataItem.id)">
                                    {{ $t('lbl_EMPBE_NotMainProd') }}
                                </span>
                            </td> -->
                            <td v-if="props.rowType !== 'groupHeader'" class="featured-cell" :onclick="handleclick(props.dataItem.productId)">

                                <span class="badge badge-light-info f-16 fontcolor"
                                    v-if="props.dataItem.isFire">
                                    <div :id="`popover-bottom_${props.dataItem.productId}`" style=" cursor:pointer"
                                        tabindex="0" @click.stop="onOpen(props.dataItem.productId)">
                                        {{ $t('lbl_EMPBE_MainProd') }}
                                    </div>
                                </span>
                                <span v-else class="badge-light badge f-16 fontcolor">
                                    <div :id="`popover-bottom_${props.dataItem.productId}`" style=" cursor:pointer"
                                        tabindex="0" @click.stop="onOpen(props.dataItem.productId)">
                                        {{ $t('lbl_EMPBE_NotMainProd') }}
                                    </div>
                                </span>

                                <!-- placement="left"  triggers="focus"-->
                                <b-popover :ref="`ref_popover_${props.dataItem.productId}`"
                                    :target="`popover-bottom_${props.dataItem.productId}`">
                                    <!-- <template #title>
                                        {{ $t('lbl_EMPBE_ModifyFeaturedProd') }}
                                    </template>
                                    <b-form-select v-model="selectedMainProd" >
                                        <option value="0">{{ $t('lbl_EMPBE_NotMainProd') }}</option>
                                        <option value="1">{{ $t('lbl_EMPBE_MainProd') }}</option>
                                    </b-form-select>
                                    <div style="padding: 10px;">
                                        <b-button variant="outline-primary" style="left: 5px;"
                                            @click="onClose(props.dataItem.productId)">{{
                                            $t('lbl_cancel') }}</b-button>
                                        &nbsp; &nbsp;
                                        <b-button variant="primary" style="right: 5px;"
                                            @click="onSave(props.dataItem.productId)">{{ $t('lbl_EMPBE_Save')
                                            }}</b-button>
                                    </div> -->
                                </b-popover>
                            </td>
                        </template>
                        <template v-slot:featuredfilterSlotTemplate="{ props, methods }">
                            <div>
                                <DropDownList :data-items="featuredProdData" :text-field="'text'" 
                                    :data-item-key="'value'" v-model="featureProdDefault" @change="(ev) => {
                                        if (ev.value.value >= 0) {
                                            serverIsMainProduct = ev.value.value > 0;
                                        } else {
                                            serverIsMainProduct = null;
                                        }
                                        skip = 0;
                                        emitServerFetch();
                                    }
                                        " />
                            </div>
                        </template>
                        <template v-slot:lastSubmitDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'" class="date-cell">
                                <!-- <custom-date :date="props.dataItem.lastSubmitDate"></custom-date> -->
                                {{ props.dataItem.lastSubmitDate }}
                            </td>
                        </template>
                        <template v-slot:lastSubmitHeaderTemplate="{ props }">
                            <div class="lastSubmit-header-cell">
                                <TipsAndPrivewDilog :id="'EMPBE_ProductInfo_lastSubmit_Info'"
                                    :Title="$t('lbl_EMPBE_ProductInfo_ProductGrid_LastSubmitted_Tips')">
                                    <template v-slot:Text>
                                        {{ props.title }}
                                    </template>
                                </TipsAndPrivewDilog>
                            </div>
                        </template>
                        <template v-slot:lastSaveDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'" class="date-cell">
                                <!-- <custom-date :date="props.dataItem.lastSaveDate"></custom-date> -->
                                  {{ props.dataItem.lastSaveDate }}
                                <span class="badge badge-warning m-r-5 m-l-5 f-16" v-if="false">
                                    <span
                                        v-if="(props.dataItem.lastSaveDate > props.dataItem.lastSubmitDate || props.dataItem.lastSubmitDate == undefined)">{{$t('lbl_EMPBE_UnsubmittedDraft')}}</span>
                                    <!-- <span v-if="(props.dataItem.lastSaveDate == props.dataItem.lastSubmitDate)">
                                        {{ $t('lbl_EMPBE_Submitted') }}</span> -->
                                </span>
                            </td>
                        </template>
                        <template v-slot:completeRateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'" class="complete-rate-cell">
                                {{ props.dataItem.completeRate == null ? '-' : (props.dataItem.completeRate + '%') }}
                            </td>
                        </template>
                        <template v-slot:launchStatusTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'" class="launch-status-cell">
                                <span class="product-launch-badge"
                                    :class="props.dataItem.launchStatus === 'online' ? 'is-online' : 'is-offline'">
                                    <span class="product-launch-badge__dot"></span>
                                    {{ props.dataItem.launchStatus === 'online'
                                        ? $t('lbl_EMPBE_Product_Online')
                                        : $t('lbl_EMPBE_Product_Offline') }}
                                </span>
                            </td>
                        </template>
                        <template v-slot:statusDateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'" class="review-status-cell">
                                <span v-if="props.dataItem.displayStatus === 'pending'" class="product-review-badge is-syncing">{{ $t('lbl_EMPBE_Ad_Status_Pending') }}</span>
                                <span v-else-if="props.dataItem.displayStatus === 'pendingManualAudit'" class="product-review-badge is-manual">{{ $t('lbl_EMPBE_Ad_Status_PendingManualAudit') }}</span>
                                <span v-else-if="props.dataItem.displayStatus === 'rejected'" class="product-review-badge is-rejected">{{ $t('lbl_EMPBE_Rejected') }}</span>
                                <span v-else-if="props.dataItem.displayStatus === 'live'" class="product-review-badge is-activated">{{ $t('lbl_EMPBE_Product_Approved') }}</span>
                                <span v-else-if="props.dataItem.displayStatus === 'delisted'" class="product-review-badge is-delisted">{{ $t('lbl_EMPBE_isDelisted') }}</span>
                                <span v-else class="product-review-badge is-not-submitted">{{ $t('lbl_EMPBE_Product_NotSubmitted') }}</span>
                            </td>
                        </template>
                        <template v-slot:FeaturedProductTemplate="{ props }">
                            <div class="status-header-cell">
                                <TipsAndPrivewDilog :id="'EMPBE_ProductInfo_Grid_FeaturedProduct_Info'"
                                    :Title="$t('lbl_EMPBE_ProductInfo_ProductGrid_FeaturedProduct_Tips')">
                                    <template v-slot:Text>
                                        {{ props.title }}
                                    </template>
                                </TipsAndPrivewDilog>
                            </div>
                        </template>
                        <!-- <template v-slot:ActivateTemplate="{ props }">
                            <td v-if="props.rowType !== 'groupHeader'">
                                <span v-if="props.dataItem.IsLaunch" class="badge-light-success badge m-r-5 m-l-5 f-16">{{
                                    $t('lbl_EMPBE_isActivate') }}</span>
                                <span v-else class="badge-light badge m-r-5 m-l-5 f-16">
                                    {{ $t('lbl_EMPBE_NotActivate') }}
                                </span>
                            </td>
                        </template> -->
                        <template v-slot:filterSlotTemplate="{ props, methods }">
                            <div>
                                <k-input :placeholder="$t('lbl_EMPBE_SearchByKeyword')" :value="serverKeyword" @input="(ev) => {
                                    serverKeyword = ev.target.value;
                                    skip = 0;
                                    debounceServerFetch();
                                }
                                    " />
                            </div>
                        </template>
                        <template v-slot:DatefilterSlotTemplate="{ props, methods }">
                            <div>
                                <DropDownList :data-items="dateSortingData" :text-field="'text'"
                                    :data-item-key="'value'" :default-item="dateSortingDefault" @change="(ev) => {
                                        applyServerSort(props.field, ev.value.value);
                                    }
                                        " />
                            </div>
                        </template>
                        <template v-slot:DateStatusfilterSlotTemplate="{ props, methods }">
                            <div class="row">
                                <div class="col-6 pr-0">
                                    <DropDownList :data-items="dateSortingData" :text-field="'text'"
                                        :data-item-key="'value'" :default-item="dateSortingDefault" @change="(ev) => {
                                            if (sort.filter(x => x.field == props.field).length > 0) {
                                                if (ev.value.value == '') {
                                                    sort = sort.filter(x => x.field != props.field)
                                                } else {
                                                    sort.find(x => x.field == props.field).dir = ev.value.value
                                                }
                                            } else if (ev.value.value != '') {
                                                sort.push({ dir: ev.value.value, field: props.field })
                                            }
                                            gridData = getData(items)
                                        }
                                            " />
                                </div>
                                <div class="col-6 pl-0">
                                    <DropDownList :data-items="statusSortingData" :text-field="'text'"
                                        :data-item-key="'value'" :default-item="statusSortingDefault" @change="(ev) => {
                                            if (ev.value.value == '') {
                                                props.onChange({ operator: '', field: '', value: '', event: ev });
                                            } else if (ev.value.value > 1) {
                                                props.onChange({
                                                    operator: 'isnotnull',
                                                    field: props.field,
                                                    value: 1,
                                                    syntheticEvent: ev,
                                                });
                                            } else {
                                                props.onChange({
                                                    operator: 'isnull',
                                                    field: props.field,
                                                    value: 1,
                                                    syntheticEvent: ev,
                                                });
                                            }
                                            resetPageAndRefresh()
                                        }
                                            " />
                                </div>
                            </div>
                        </template>
                        <template v-slot:CompleteRatefilterSlotTemplate="{ props, methods }">
                            <div>
                                <DropDownList :data-items="dateSortingData" :text-field="'text'"
                                    :data-item-key="'value'" :default-item="completeRateFilterDefault" @change="(ev) => {
                                        applyServerSort('completeRate', ev.value.value);
                                    }
                                        " />
                            </div>
                        </template>
                        <template v-slot:LaunchStatusfilterSlotTemplate="{ props, methods }">
                            <DropDownList :data-items="launchStatusSortingData" :text-field="'text'" :data-item-key="'value'"
                                :default-item="statusSortingDefault" @change="(ev) => {
                                    serverLaunchStatus = ev.value.value || '';
                                    skip = 0;
                                    emitServerFetch();
                                }
                                    " />
                        </template>
                        <template v-slot:StatusfilterSlotTemplate="{ props, methods }">
                            <DropDownList :data-items="statusSortingData" :text-field="'text'" :data-item-key="'value'"
                                :default-item="statusSortingDefault" @change="(ev) => {
                                    serverReviewStatus = ev.value.value || '';
                                    skip = 0;
                                    emitServerFetch();
                                }
                                    " />
                        </template>
                    </Grid>
                    </div>
                    </div>
                </intl>
            </localization>
        </b-overlay>
        <visitorPermissionPopup PopupUid="PopupProduct"></visitorPermissionPopup>
        <b-modal id="product-bulk-delete-modal" v-model="deleteModal.show" centered hide-header hide-footer
            modal-class="product-bulk-modal" dialog-class="product-bulk-modal__dialog"
            content-class="product-bulk-modal__content" body-class="product-bulk-modal__body">
            <template v-if="deleteModal.mode === 'done'">
                <div class="product-bulk-modal__title">
                    {{ deleteModal.action === 'Delist'
                        ? $t('lbl_EMPBE_DelistSuccess')
                        : $t('lbl_EMPBE_ProductInfo_BulkDeletedTitle') }}
                </div>
                <div class="product-bulk-modal__text">
                    {{ deleteModal.action === 'Delist'
                        ? $t('lbl_EMPBE_ProductInfo_BulkDelistedBody', { selected: deleteModal.deletedCount })
                        : $t('lbl_EMPBE_ProductInfo_BulkDeletedBody', { selected: deleteModal.deletedCount }) }}
                </div>
            </template>
            <template v-else-if="deleteModal.mode === 'partial'">
                <div class="product-bulk-modal__title">
                    {{ deleteModal.action === 'Delist'
                        ? $t('lbl_EMPBE_ProductInfo_BulkDelistPartialTitle', { ableToDelist: deleteModal.deletable.length })
                        : $t('lbl_EMPBE_ProductInfo_BulkDeletePartialTitle', { ableToDelete: deleteModal.deletable.length }) }}
                </div>
                <div class="product-bulk-modal__text">
                    {{ deleteModal.action === 'Delist'
                        ? $t('lbl_EMPBE_ProductInfo_BulkDelistPartialBody', { failedToDelist: deleteModal.failedCount })
                        : $t('lbl_EMPBE_ProductInfo_BulkDeletePartialBody', { failedToDelete: deleteModal.failedCount }) }}
                </div>
                <div class="product-bulk-modal__warn">
                    <div class="product-bulk-modal__warn-title">{{ $t('lbl_EMPBE_ProductInfo_BulkDeletePartialImpact') }}</div>
                    <ul v-if="deleteModal.linkedLines && deleteModal.linkedLines.length" class="product-bulk-modal__warn-list">
                        <li v-for="(line, idx) in deleteModal.linkedLines" :key="'linked-' + idx">{{ line }}</li>
                    </ul>
                    <div v-else>{{ deleteModal.action === 'Delist'
                        ? $t('lbl_EMPBE_ProductDeleteCheck_LinkedAdDelist')
                        : $t('lbl_EMPBE_ProductDeleteCheck_LinkedAd') }}</div>
                </div>
            </template>
            <template v-else-if="deleteModal.mode === 'blocked'">
                <div class="product-bulk-modal__title">{{ deleteModal.notice }}</div>
                <div v-if="deleteModal.linkedLines && deleteModal.linkedLines.length" class="product-bulk-modal__warn">
                    <div class="product-bulk-modal__warn-title">{{ $t('lbl_EMPBE_ProductInfo_BulkDeletePartialImpact') }}</div>
                    <ul class="product-bulk-modal__warn-list">
                        <li v-for="(line, idx) in deleteModal.linkedLines" :key="'blocked-linked-' + idx">{{ line }}</li>
                    </ul>
                </div>
            </template>
            <template v-else>
                <div class="product-bulk-modal__title">
                    {{ deleteModal.action === 'Delist'
                        ? $t('lbl_EMPBE_ProductInfo_BulkDelistTitle', { selected: deleteModal.deletable.length })
                        : $t('lbl_EMPBE_ProductInfo_BulkDeleteTitle', { selected: deleteModal.deletable.length }) }}
                </div>
                <div class="product-bulk-modal__text">
                    {{ deleteModal.action === 'Delist'
                        ? $t('lbl_EMPBE_ProductInfo_BulkDelistBody')
                        : $t('lbl_EMPBE_ProductInfo_BulkDeleteBody') }}
                </div>
            </template>
            <div class="product-bulk-modal__actions">
                <button
                    v-if="deleteModal.mode === 'simple' || deleteModal.mode === 'partial'"
                    type="button"
                    class="product-bulk-modal__cancel"
                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnBulkDeleteClose'"
                    @click="closeDeleteModal"
                >
                    {{ $t('lbl_EMPBE_ProductInfo_Delete_Cancel') }}
                </button>
                <button
                    v-if="deleteModal.mode === 'simple' || deleteModal.mode === 'partial'"
                    type="button"
                    :class="deleteModal.action === 'Delist' ? 'product-bulk-modal__primary' : 'product-bulk-modal__danger'"
                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnBulkDeleteConfirm'"
                    :disabled="bulkBusy"
                    @click="confirmBulkDelete"
                >
                    {{ deleteModal.action === 'Delist'
                        ? (deleteModal.mode === 'partial'
                            ? $t('lbl_EMPBE_ProductInfo_BulkDelistOther')
                            : $t('lbl_EMPBE_ProductInfo_BulkDelistConfirm'))
                        : (deleteModal.mode === 'partial'
                            ? $t('lbl_EMPBE_ProductInfo_BulkDeleteOther')
                            : $t('lbl_EMPBE_ProductInfo_BulkDeleteConfirm')) }}
                </button>
                <button
                    v-if="deleteModal.mode === 'done' || deleteModal.mode === 'blocked'"
                    type="button"
                    class="product-bulk-modal__primary"
                    v-bind:t_label="'EMPBE_ProductInfoCenter_Product_btnBulkDeleteClose'"
                    @click="closeDeleteModal"
                >
                    {{ $t('lbl_EMPBE_Ok') }}
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { InquiryFormService } from '../../_services'
import visitorPermissionPopup from '@/components/visitorPermissionPopup'
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { Input } from '@progress/kendo-vue-inputs';
import { Button } from '@progress/kendo-vue-buttons';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { process } from '@progress/kendo-data-query';
import { DateRangePicker } from '@progress/kendo-vue-dateinputs';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl';
import { productService, hasProductListDraftIndicator, PRODUCT_DISPLAY_STATUS } from '@/_services/product.service';
import CustomStartDateInput from '../../components/form/dateRangePicker/customStartDateInput.vue';
import CustomEndDateInput from '../../components/form/dateRangePicker/customEndDateInput.vue';

import { IsUAT } from '../../constants/config';

export default {
    inject: {
        permissionData: { default: null },
        ChildSubmit: { default: null },
    },
    props: ["Records", "otherInfo", "addToCart","fromAdmin", "totalCount"],
    components: {
        Grid: Grid,
        toolbar: GridToolbar,
        localization: LocalizationProvider,
        intl: IntlProvider,
        'k-input': Input,
        kbutton: Button,
        DropDownList,
        visitorPermissionPopup: visitorPermissionPopup,
        DateRangePicker,
        CustomStartDateInput,
        CustomEndDateInput
    },
    data() {
        return {
            IsUAT: IsUAT,
            loading: false,
            error: null,
            totalRows: 1,
            currentPage: 1,
            items: [],
            gridData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            rowSelected: [],
            skip: 0,
            take: 10,
            group: [],
            sort: [],
            filter: {
                logic: 'and',
                filters: [],
            },
            gridPageable: {
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
            },
            searchWord: '',
            selectedField: 'selected',
            columnMenu: false,
            selectedMainProd: 1,
            featuredProdData: [
                { value: -1, text: this.$t('Lbl_PleaseSelect') },
                { value: 1, text: this.$t("lbl_EMPBE_MainProd") },
                { value: 0, text: this.$t("lbl_EMPBE_NotMainProd") }
            ],
            featureProdDefault: { value: -1, text: this.$t('Lbl_PleaseSelect') },
            dateSortingData: [
                { value: "asc", text: this.$t("lbl_EMP2_Sort_Asc") },
                { value: "desc", text: this.$t("lbl_EMP2_Sort_Dsc") }
            ],
            dateSortingDefault: { value: '', text: this.$t('Lbl_News_SortByDate') },
            statusSortingData: [
                { value: 'live', text: this.$t("lbl_EMPBE_Product_Approved") },
                { value: 'toBeSubmitted', text: this.$t("lbl_EMPBE_Product_NotSubmitted") },
                { value: 'pending', text: this.$t("lbl_EMPBE_Ad_Status_Pending") },
                { value: 'pendingManualAudit', text: this.$t("lbl_EMPBE_Ad_Status_PendingManualAudit") },
                { value: 'rejected', text: this.$t("lbl_EMPBE_Rejected") },
            ],
            launchStatusSortingData: [
                { value: 'online', text: this.$t("lbl_EMPBE_Product_Online") },
                { value: 'offline', text: this.$t("lbl_EMPBE_Product_Offline") },
            ],
            statusSortingDefault: { value: '', text: this.$t('lbl_EMPBE_FilterBy') },
            completeRateFilterDefault: { value: '', text: this.$t('lbl_EMPBE_AdList_FilterBy') },
            serverKeyword: '',
            serverProductId: '',
            serverIsMainProduct: null,
            serverLaunchStatus: '',
            serverReviewStatus: '',
            serverSortField: '',
            serverSortDir: '',
            serverFetchTimer: null,
            mainProductCount:0,
            bulkBusy: false,
            deleteModal: {
                show: false,
                mode: 'simple',
                action: 'Delete',
                deletable: [],
                failedCount: 0,
                deletedCount: 0,
                linkedLines: [],
                notice: '',
            },
            adPageNameMap: {
                bannerAd: 'lbl_EMPBE_BannerAd',
                logoAd: 'lbl_EMPBE_LogoAd',
                buttonAd: 'lbl_EMPBE_ButtonAd',
                landingAd: 'lbl_EMPBE_LandingPageAd',
                videoAd: 'lbl_EMPBE_VideoAd',
                starAd: 'lbl_EMPBE_StarAd',
                catListAd: 'lbl_EMPBE_CatListAd',
                priorityAd: 'lbl_EMPBE_priorityAds',
            },
        };
    },
    created() {
        this.bindServerGridData();
    },
    computed: {   
        GetMainProductCount(){
            if(this.permissionData)
            {
                switch(this.permissionData["Type"]){
                    case "A+":
                    return 10;
                    case "A":
                    return 5;
                    case "B":
                    return 2;
                    case "Member":
                    return 1;
                }
            }
            return 0;
        },
        AplusABCBasicBooth() {
            if (this.permissionData) {
                return ["A+","A", "B", "C","Member"].includes(this.permissionData["Type"]);
            } else {
                return false;
            }
        },
        // GetRecordsEffective(){
        //     return this.Records ?  (this.Records.filter(item=>item.state == 2).length) : 0;
        // },
        langId() {
            return localStorage.getItem("currentLangId");
        },
        user() {
            return this.$store.state.authentication.user;
        },
        companyid() {
            return this.user.empCompanyId;
        },
        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        },
        selectedDataItems() {
            const rows = this.gridData && this.gridData.data ? this.gridData.data : [];
            return rows.filter((item) => item.selected === true);
        },
        areAllSelected() {
            return (
                this.selectedDataItems.length === this.gridData.data.length &&
                this.selectedDataItems.length !== 0
            );
        },
        hasActiveFilters() {
            return !!(
                (this.serverKeyword && String(this.serverKeyword).trim())
                || (this.serverProductId && String(this.serverProductId).trim())
                || this.serverLaunchStatus
                || this.serverReviewStatus
                || this.serverIsMainProduct !== null
                || this.serverSortField
            );
        },
        // 仅公司真正没有产品时显示空态；筛选无结果仍保留表格
        showEmptyCompanyState() {
            const noRows = !this.Records || this.Records.length <= 0;
            if (!noRows) return false;
            if (this.hasActiveFilters) return false;
            if (this.totalCount > 0) return false;
            if (this.otherInfo && this.otherInfo.product_OccupiedCount > 0) return false;
            return true;
        },
        columns() {
            // Like AdListView minmax(minPx, %): % fills wide screens; CSS min-width + shell min-width hold floors when narrow.
            const cols = [];
            if (!this.fromAdmin) {
                cols.push({
                    field: 'selected',
                    width: '4%',
                    headerSelectionValue: this.areAllSelected,
                    filterable: false,
                    columnMenu: false,
                    resizable: false,
                    headerClassName: 'product-select-col',
                    className: 'product-select-col',
                });
            }
            cols.push(
                { field: 'name', title: this.$t("lbl_EMPBE_ProductInfo_ProductGrid_ProductName"), cell: 'productIdTemplate', headerCell: 'productNameHeaderTemplate', filterCell: 'filterSlotTemplate', width: this.fromAdmin ? '20%' : '22%', minResizableWidth: 200, headerClassName: 'product-name-col', className: 'product-name-col' },
            );
            if (this.fromAdmin) {
                cols.push({
                    field: 'productId',
                    title: this.$t('lbl_EMPBE_ProductInfo_ProductGrid_ProductId'),
                    cell: 'productIdColumnTemplate',
                    filterCell: 'productIdFilterSlotTemplate',
                    width: '8%',
                    minResizableWidth: 90,
                    headerClassName: 'product-id-col',
                    className: 'product-id-col',
                });
            }
            cols.push(
                { field: 'completeRate', title: this.$t("lbl_EMPBE_Product_CompleteRate"), cell: 'completeRateTemplate', filterCell: 'CompleteRatefilterSlotTemplate', width: this.fromAdmin ? '9%' : '10%', minResizableWidth: 100, headerClassName: 'complete-rate-col', className: 'complete-rate-col' },
                { field: 'isFire', title: this.$t("lbl_EMPBE_ProductInfo_ProductGrid_FeaturedProduct"), cell: 'isFireTemplate', headerCell: "FeaturedProductTemplate", filter: 'boolean', filterCell: 'featuredfilterSlotTemplate', hidden: this.user.memberCode == 'FREE', width: this.fromAdmin ? '15%' : '16%', minResizableWidth: 160, headerClassName: 'featured-col', className: 'featured-col' },
                { field: 'launchStatus', title: this.$t("lbl_EMPBE_ProductsStatus"), cell: 'launchStatusTemplate', filterCell: 'LaunchStatusfilterSlotTemplate', width: this.fromAdmin ? '11%' : '12%', minResizableWidth: 110, headerClassName: 'launch-status-col', className: 'launch-status-col' },
                { field: 'displayStatus', title: this.$t("lbl_EMPBE_ReviewStatus"), cell: 'statusDateTemplate', filterCell: 'StatusfilterSlotTemplate', width: this.fromAdmin ? '13%' : '14%', minResizableWidth: 140, headerClassName: 'review-status-col', className: 'review-status-col' },
                { field: 'lastSaveDate', title: this.$t("lbl_EMPBE_ProductInfo_ProductGrid_LastUpdated"), cell: 'lastSaveDateTemplate', filter: 'date', type: "date", format: '{0:yyyy-MM-dd HH:mm:ss}', filterCell: 'DatefilterSlotTemplate', width: this.fromAdmin ? '12%' : '11%', minResizableWidth: 140, headerClassName: 'date-col', className: 'date-col' },
                { field: 'lastSubmitDate', title: this.$t("lbl_EMPBE_ProductInfo_ProductGrid_LastSubmitted"), cell: 'lastSubmitDateTemplate', headerCell: "lastSubmitHeaderTemplate", filter: 'date', type: "date", format: '{0:yyyy-MM-dd HH:mm:ss}', filterCell: 'DatefilterSlotTemplate', width: this.fromAdmin ? '12%' : '11%', minResizableWidth: 140, headerClassName: 'date-col', className: 'date-col' },
            );
            return cols;
        },
        kendoLang() {
            switch (this.langId) {
                case "1252":
                    return "en-US";
                case "950":
                    return "zh-Hant";
                case "936":
                    return "zh-Hans";
                default:
                    return "zh-Hans";
            }
        },
    },
    mounted() {
        this.itemsRecordProcess();
        this.bindServerGridData();
        this.GetMainProductCountAsync();

        this.$nextTick(() => {
            window.dispatchEvent(new Event('resize'));
            this.bindSelectHeaderBlankClick();
        });
    },
    beforeDestroy() {
        this.unbindSelectHeaderBlankClick();
    },
    watch: {
        Records() {
            this.itemsRecordProcess();
            this.bindServerGridData();
            this.$nextTick(() => this.bindSelectHeaderBlankClick());
        },
        totalCount() {
            this.bindServerGridData();
        }
    },

    methods: {
        getProductGridEl() {
            if (this.$refs.grid && this.$refs.grid.$el) return this.$refs.grid.$el;
            return this.$el && this.$el.querySelector('#product-prod-grid');
        },
        bindSelectHeaderBlankClick() {
            this.unbindSelectHeaderBlankClick();
            const gridEl = this.getProductGridEl();
            if (!gridEl) return;
            this._selectHeaderGridEl = gridEl;
            // 表头勾选列：点空白/label 都直接全选，仅点到 input 本身走 headerselectionchange
            this._onSelectHeaderBlankClick = (e) => {
                const header = gridEl.querySelector('.k-grid-header');
                if (!header || !header.contains(e.target)) return;
                const th = e.target.closest && e.target.closest('th');
                if (!th || !header.contains(th)) return;
                const tr = th.parentElement;
                if (tr && tr.classList.contains('k-filter-row')) return;
                const input = th.querySelector('input.k-checkbox, input[type="checkbox"]');
                if (!input) return;
                if (e.target === input) return;
                e.preventDefault();
                e.stopImmediatePropagation();
                this.applyHeaderSelection(!input.checked);
            };
            gridEl.addEventListener('click', this._onSelectHeaderBlankClick, true);
        },
        unbindSelectHeaderBlankClick() {
            if (this._selectHeaderGridEl && this._onSelectHeaderBlankClick) {
                this._selectHeaderGridEl.removeEventListener('click', this._onSelectHeaderBlankClick, true);
            }
            this._selectHeaderGridEl = null;
            this._onSelectHeaderBlankClick = null;
        },
        applyHeaderSelection(checked) {
            const flag = !!checked;
            const mark = (list) => {
                if (!Array.isArray(list)) return;
                list.forEach((item) => {
                    if (item) this.$set(item, this.selectedField, flag);
                });
            };
            mark(this.gridData && this.gridData.data);
            mark(this.items);
            mark(this.Records);
        },
      hasRowDraftIndicator(row) {
        if (row && typeof row.showDraftPill === 'boolean') return row.showDraftPill;
        return hasProductListDraftIndicator(row);
      },
      GetMainProductCountAsync() {
        productService
            .GetMainProductCountAsync({ companyId: this.companyid})
            .then((res) => {
                if (res.isSuccessful) {
                    this.mainProductCount = res.data.counts;
                }
            }).catch(() => {
            })
        },
        buildServerQuery() {
            const productId = String(this.serverProductId || '').trim();
            return {
                pageNumber: Math.floor(this.skip / this.take) + 1,
                pageSize: this.take,
                keyword: this.serverKeyword || '',
                productId: productId || null,
                isMainProduct: this.serverIsMainProduct,
                launchStatus: this.serverLaunchStatus || '',
                reviewStatus: this.serverReviewStatus || '',
                sortField: this.serverSortField || '',
                sortDir: this.serverSortDir || '',
            };
        },
        emitServerFetch() {
            this.$emit('fetch', this.buildServerQuery());
        },
        debounceServerFetch() {
            if (this.serverFetchTimer) {
                clearTimeout(this.serverFetchTimer);
            }
            this.serverFetchTimer = setTimeout(() => {
                this.emitServerFetch();
            }, 400);
        },
        applyServerSort(field, dir) {
            if (!dir) {
                this.serverSortField = '';
                this.serverSortDir = '';
            } else {
                this.serverSortField = field;
                this.serverSortDir = dir;
            }
            this.skip = 0;
            this.emitServerFetch();
        },
        bindServerGridData() {
            this.gridData = {
                data: this.Records || [],
                total: this.totalCount == null ? (this.Records ? this.Records.length : 0) : this.totalCount,
            };
        },
        onRowClick(event) {
            const clickTarget = event.event && event.event.target;
            // checkbox 由 onSelectionChange 处理，避免双重 toggle
            if (clickTarget && clickTarget.closest
                && clickTarget.closest('.k-checkbox, .k-checkbox-wrap, .k-checkbox-label, input[type="checkbox"]')) {
                return;
            }
            // 勾选列空白：与 checkbox 同样切换选中
            if (clickTarget && clickTarget.closest && clickTarget.closest('td.product-select-col')) {
                if (!this.fromAdmin && event.dataItem) {
                    this.$set(event.dataItem, this.selectedField, !event.dataItem[this.selectedField]);
                }
                return;
            }
            if (clickTarget && clickTarget.closest && clickTarget.closest('.Goto-ProductDetail-edit, .edit-badge')) {
                return;
            }
            if (clickTarget && clickTarget.closest && clickTarget.closest('.featured-cell [id^="popover-bottom_"], .b-popover')) {
                return;
            }
            const productOrCatalogId = event.dataItem && event.dataItem.productId;
            if (this.fromAdmin) {
                this.$emit('row-click', { productOrCatalogId, type: 'product' });
                return;
            }
            // 其它列进详情，不改勾选
            this.goProductDetail(productOrCatalogId);
        },
        goProductDetail(productId, event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            if (!productId && productId !== 0) return;
            this.$router.push(`/productInfoCenter/productDetail/${productId}`);
        },
        
        test() {
            this.$router.push(
                '/productInfoCenter/productDetail/8067'
            );
        },
        itemsRecordProcess() {
            var r = this.Records;
            this.items = r;
        },
        handleclick(id) {
            // console.log("handleclick,id:" + id)

        },
        onSelectionChange(event) {
            if (!event || !event.dataItem) return;
            this.$set(event.dataItem, this.selectedField, !event.dataItem[this.selectedField]);
        },
        handleFilterChange: function (ev) {
            this.filter = ev.filter;
        },
        filterChange: function (ev) {
            this.filter = ev.filter;
        },
        filterRender: function (h, defaultRendering, props, change) {
            return defaultRendering;
        },
        createAppState: function (dataState) {
            this.group = dataState.group;
            this.take = dataState.take;
            this.skip = dataState.skip;
            this.sort = dataState.sort;
            this.filter = dataState.filter;
            this.emitServerFetch();
        },
        dataStateChange: function (event) {
            this.createAppState(event.data); 
        },
        onFilter(e) {
            this.serverKeyword = this.searchWord || '';
            this.skip = 0;
            this.emitServerFetch();
        },
        getData(data) {
            return {
                data: data || [],
                total: this.totalCount == null ? (data ? data.length : 0) : this.totalCount,
            };
        },
        resetPageAndRefresh() {
            this.skip = 0;
            this.emitServerFetch();
        },
        onHeaderSelectionChange(event) {
            const checked = !!(event.event && event.event.target && event.event.target.checked);
            this.applyHeaderSelection(checked);
        },
        clearSelection() {
            this.applyHeaderSelection(false);
        },
        selectedProductIds() {
            return this.selectedDataItems.map((item) => item.productId).filter((id) => id);
        },
        isPendingReviewStatus(item) {
            const status = item && item.displayStatus;
            return status === PRODUCT_DISPLAY_STATUS.pending
                || status === PRODUCT_DISPLAY_STATUS.pendingManualAudit;
        },
        selectedHasPendingReview() {
            return this.selectedDataItems.some((item) => this.isPendingReviewStatus(item));
        },
        showPendingBlockedModal(action) {
            this.deleteModal = {
                show: true,
                mode: 'blocked',
                action,
                deletable: [],
                failedCount: 0,
                deletedCount: 0,
                linkedLines: [],
                notice: action === 'Delist'
                    ? this.$t('lbl_EMPBE_ProductInfo_BulkDelistBlockedPending')
                    : this.$t('lbl_EMPBE_ProductInfo_BulkDeleteBlockedPending'),
            };
        },
        async batchProductAction(action, commit, productIds) {
            const res = await productService.BatchProductAction({
                companyId: this.companyid,
                productIds: productIds || this.selectedProductIds(),
                action,
                commit,
            });
            const body = (res && res.data) || {};
            return {
                ok: !!(res && res.isSuccessful),
                readyIds: body.readyIds || body.ReadyIds || [],
                doneIds: body.doneIds || body.DoneIds || [],
                linkedAdIds: body.linkedAdIds || body.LinkedAdIds || [],
                inApprovalIds: body.inApprovalIds || body.InApprovalIds || [],
                failedIds: body.failedIds || body.FailedIds || [],
                linkedImpacts: body.linkedImpacts || body.LinkedImpacts || [],
            };
        },
        resolveAdPageLabel(pageType) {
            const key = this.adPageNameMap[pageType];
            return key ? this.$t(key) : pageType;
        },
        buildLinkedImpactLines(linkedImpacts, linkedAdIds) {
            const impacts = Array.isArray(linkedImpacts) ? linkedImpacts : [];
            if (impacts.length) {
                const lang = String(this.langId || '');
                return impacts.map((item) => {
                    const productName = lang === '936'
                        ? (item.productNameS || item.ProductNameS)
                        : lang === '950'
                            ? (item.productNameT || item.ProductNameT)
                            : (item.productNameE || item.ProductNameE);
                    const fallbackName = this.selectedDataItems.find(
                        (row) => String(row.productId) === String(item.productId || item.ProductId)
                    );
                    const affectedSection = productName || (fallbackName && fallbackName.name) || String(item.productId || item.ProductId || '');
                    const pageTypes = String(item.pageTypes || item.PageTypes || '')
                        .split(',')
                        .map((t) => t.trim())
                        .filter(Boolean);
                    const adLabels = [...new Set(pageTypes.map((t) => this.resolveAdPageLabel(t)))].filter(Boolean);
                    return this.$t('lbl_EMPBE_ProductInfo_BulkLinkedImpactLine', {
                        affectedSection,
                        afftectedAdOrProduct: adLabels.join(', '),
                    });
                });
            }
            // API 未返回明细时：至少列出产品名
            return (linkedAdIds || []).map((id) => {
                const row = this.selectedDataItems.find((item) => String(item.productId) === String(id));
                return (row && row.name) || String(id);
            });
        },
        async delistSelected() {
            if (this.bulkBusy || !this.selectedDataItems.length) return;
            if (this.selectedHasPendingReview()) {
                this.showPendingBlockedModal('Delist');
                return;
            }
            this.bulkBusy = true;
            try {
                const preview = await this.batchProductAction('Delist', false);
                if ((preview.inApprovalIds || []).length) {
                    this.showPendingBlockedModal('Delist');
                    return;
                }
                if (!preview.readyIds.length) {
                    this.deleteModal = {
                        show: true,
                        mode: 'blocked',
                        action: 'Delist',
                        deletable: [],
                        failedCount: preview.linkedAdIds.length,
                        deletedCount: 0,
                        linkedLines: this.buildLinkedImpactLines(preview.linkedImpacts, preview.linkedAdIds),
                        notice: this.$t('lbl_EMPBE_ProductDeleteCheck_LinkedAdDelist'),
                    };
                    return;
                }
                this.deleteModal = {
                    show: true,
                    mode: preview.linkedAdIds.length ? 'partial' : 'simple',
                    action: 'Delist',
                    deletable: preview.readyIds,
                    failedCount: preview.linkedAdIds.length,
                    deletedCount: 0,
                    linkedLines: this.buildLinkedImpactLines(preview.linkedImpacts, preview.linkedAdIds),
                    notice: '',
                };
            } finally {
                this.bulkBusy = false;
            }
        },
        async askDeleteSelected() {
            if (this.bulkBusy || !this.selectedDataItems.length) return;
            if (this.selectedHasPendingReview()) {
                this.showPendingBlockedModal('Delete');
                return;
            }
            this.bulkBusy = true;
            try {
                const result = await this.batchProductAction('Delete', false);
                if ((result.inApprovalIds || []).length) {
                    this.showPendingBlockedModal('Delete');
                    return;
                }
                if (!result.readyIds.length) {
                    this.deleteModal = {
                        show: true,
                        mode: 'blocked',
                        action: 'Delete',
                        deletable: [],
                        failedCount: result.linkedAdIds.length,
                        deletedCount: 0,
                        linkedLines: this.buildLinkedImpactLines(result.linkedImpacts, result.linkedAdIds),
                        notice: this.$t('lbl_EMPBE_ProductDeleteCheck_LinkedAd'),
                    };
                    return;
                }
                this.deleteModal = {
                    show: true,
                    mode: result.linkedAdIds.length ? 'partial' : 'simple',
                    action: 'Delete',
                    deletable: result.readyIds,
                    failedCount: result.linkedAdIds.length,
                    deletedCount: 0,
                    linkedLines: this.buildLinkedImpactLines(result.linkedImpacts, result.linkedAdIds),
                    notice: '',
                };
            } finally {
                this.bulkBusy = false;
            }
        },
        async confirmBulkDelete() {
            const targets = this.deleteModal.deletable || [];
            if (this.bulkBusy || !targets.length) return;
            this.bulkBusy = true;
            try {
                const action = this.deleteModal.action === 'Delist' ? 'Delist' : 'Delete';
                const result = await this.batchProductAction(action, true, targets);
                this.clearSelection();
                this.deleteModal = {
                    show: true,
                    mode: 'done',
                    action,
                    deletable: [],
                    deletedCount: result.doneIds.length,
                    linkedLines: [],
                    notice: '',
                };
                if (result.doneIds.length) {
                    this.$emit('refreshGrid');
                }
            } finally {
                this.bulkBusy = false;
            }
        },
        closeDeleteModal() {
            this.deleteModal.show = false;
        },
        openOrderingPage() {
            this.$root.$emit('bv::toggle::collapse', 'OrderRightpopup');
        },
        openMembershipInfoPage() {
            const localeStr = this.langId === "936" ? "simp" : this.langId === "950" ? "trad" : this.langId === "1252" ? "eng" : "simp";
            const newWindow = window.open(`https://www.chinaplasonline.com/eMarketplace/Supplier/${localeStr}`, '_blank');

            newWindow.addEventListener('DOMContentLoaded', function () {
                const targetElement = newWindow.document.querySelector('#supplier_MembershipsBenefits');
                let destY = targetElement.offsetTop;

                const stickyHeader = newWindow.document.querySelector('.sticky-header');
                destY -= stickyHeader.offsetHeight;

                newWindow.scrollTo({ top: destY, behavior: "smooth" });
            });
        },
        onOpen(id) {
            this.selectedMainProd = 0;
            this.items.forEach(element => {
                console.log(element)
                if (element.id == id) {
                    this.selectedMainProd = element.isFire ? 1 : 0;
                    this.$refs['ref_popover_' + id].$emit('open')
                } else {
                    this.onClose(element.id)
                }
            });
        },
        onClose(id) {
            if( this.$refs['ref_popover_' + id])
            this.$refs['ref_popover_' + id].$emit('close')
        },
        async onSave(id) {
            var that = this;
            //[19112024][SJP] Per isaac request, remove mainproduct count checking
            // if (this.selectedMainProd == 1) {
            //     var checkMainProdCount = await this.GetProductMainProdCount(id);
            //     if (!checkMainProdCount) {
            //         return;
            //     }
            // }
            if(this.GetMainProductCount <= this.mainProductCount && this.selectedMainProd==1 )
            {
                this.alertMsg(that.$t('lbl_EMPBE_ProductInfoIsMainError'))
                return;
            }
            var parms = { productid: id, isMainProduct: this.selectedMainProd };
            productService.UpdateProductMainProd(parms).then((res) => {
                if (res.isSuccessful) {
                    var message = that.$t('lbl_EMPBE_SaveSuccess');
                    that.alertMsg(message)
                    this.$emit('refreshGrid');
                    this.GetMainProductCountAsync();
                } else {
                    var message = that.$t('lbl_EMPBE_Oprate_Filed');
                    that.alertMsg(message)
                }
                that.onClose(id)
            });
        },
        async GetProductMainProdCount(id) {
            var that = this;
            return productService.GetProductMainProdCount({ CompanyId: this.companyid, productId: id })
                .then((result) => {
                    if (result.isSuccessful && that.permissionData != null) {
                        if (result.data + 1 <= that.permissionData.MaxMainProdAmount) {
                            return true;
                        }
                    }
                    var message = that.$t('lbl_EMPBE_OverMainProdAmount');
                    that.alertMsg(message);
                    that.onClose(id)
                    return false;
                });
        },
        alertMsg(message) {
            this.$swal({
                text: message,
                showCancelButton: false,
            });
        },
        onDateRangePickerChange(e, props) {
            const currentFilters = this.filter.filters;

            const isDateRangeFilterApplied =
                currentFilters.filter((el) => el.customOperator == props.field).length !== 0;

            if (isDateRangeFilterApplied) {
                const index = currentFilters.map((e) => e.customOperator).indexOf(props.field);
                currentFilters.splice(index, 1);
            }

            var newFilters = [];
            if (e.value.start) {
                newFilters.push({
                    field: props.field,
                    operator: 'gte',
                    value: e.value.start,
                })
            }
            if (e.value.end) {
                newFilters.push({
                    field: props.field,
                    operator: 'lte',
                    value: e.value.end,
                })
            }

            this.filter.filters.push({
                customOperator: props.field,
                logic: 'and',
                filters: newFilters,
            });
            this.gridData = this.getData(this.items);
        },
        checkLaunchLimit() {
            this.$router.replace('/productInfoCenter/productDetail/0');
        },
        async GenerateQRCode() {
            console.log('g')
            return true
        }
    },
};
</script>
<style >
 

/* Match AdListView exactly:
   shell = width:100% + overflow-x:auto
   content = min-width floor + width:100% (fills when wide; scrolls when narrow)
*/
.product-grid-wrap {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.product-grid-wrap .b-overlay-wrap {
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
}
.product-grid-table-shell {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.product-grid-table-min {
  /* same role as .ad-list-chrome / .ad-list-body min-width: 1180px */
  min-width: 1220px;
  width: 100%;
  box-sizing: border-box;
}
.product-grid-table-min--admin {
  min-width: 1330px;
}
#product-prod-grid.k-grid {
  width: 100% !important;
  min-width: 1220px !important;
  max-width: none !important;
  box-sizing: border-box;
}
#product-prod-grid.product-grid--admin.k-grid {
  min-width: 1330px !important;
}
#product-prod-grid .k-grid-header-wrap,
#product-prod-grid .k-grid-content {
  overflow-x: hidden !important;
}
#product-prod-grid .k-grid-header table,
#product-prod-grid .k-grid-content table,
#product-prod-grid .k-grid-table,
#product-prod-grid table {
  table-layout: fixed;
  width: 100% !important;
  min-width: 1220px !important;
}
#product-prod-grid.product-grid--admin .k-grid-header table,
#product-prod-grid.product-grid--admin .k-grid-content table,
#product-prod-grid.product-grid--admin .k-grid-table,
#product-prod-grid.product-grid--admin table {
  min-width: 1330px !important;
}
 
.k-animation-container-shown{
    z-index: 10014 !important;
}

.fontcolor:hover {
    color: #a927f9;
}

.k-daterangepicker .k-floating-label-container {
    padding-left: 40px !important;
    padding-top: 0px !important;
}
/* Title row stays tall enough for the bulk actions, so selecting rows does not shift the page. */
#product-prod-grid:not(.product-grid--admin) .k-grid-header thead > tr:first-child > th {
  height: 48px;
  box-sizing: border-box;
}
#product-prod-grid:not(.product-grid--admin) .k-grid-header thead > tr:first-child > th .k-cell-inner,
#product-prod-grid:not(.product-grid--admin) .k-grid-header thead > tr:first-child > th .k-link {
  min-height: 48px;
  display: flex;
  align-items: center;
}

/* Column floors only (like minmax minPx) — do NOT lock width in px or wide screens leave a gap */
#product-prod-grid .k-grid-header .k-header.product-name-col,
#product-prod-grid td.product-name-col,
#product-prod-grid td.product-name-cell {
  min-width: 240px !important;
  box-sizing: border-box;
}
/* 勾选列居中：只改对齐，不改列宽 */
#product-prod-grid .k-grid-header .k-header.product-select-col,
#product-prod-grid td.product-select-col {
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
}
#product-prod-grid .k-grid-header .k-header.product-select-col .k-cell-inner,
#product-prod-grid .k-grid-header .k-header.product-select-col .k-link {
  justify-content: center;
}
#product-prod-grid .k-grid-header .k-header.product-id-col,
#product-prod-grid td.product-id-col,
#product-prod-grid td.product-id-cell {
  min-width: 90px !important;
  box-sizing: border-box;
}
#product-prod-grid .k-grid-header .k-header.complete-rate-col,
#product-prod-grid td.complete-rate-col,
#product-prod-grid td.complete-rate-cell {
  min-width: 100px !important;
  white-space: nowrap;
  box-sizing: border-box;
}
#product-prod-grid .k-grid-header .k-header.featured-col,
#product-prod-grid td.featured-col,
#product-prod-grid td.featured-cell {
  min-width: 160px !important;
  overflow: hidden;
  box-sizing: border-box;
}
#product-prod-grid .k-grid-header .k-header.launch-status-col,
#product-prod-grid td.launch-status-col,
#product-prod-grid td.launch-status-cell {
  min-width: 110px !important;
  box-sizing: border-box;
}
#product-prod-grid .k-grid-header .k-header.review-status-col,
#product-prod-grid td.review-status-col,
#product-prod-grid td.review-status-cell {
  min-width: 140px !important;
  overflow: hidden;
  box-sizing: border-box;
}
#product-prod-grid .k-grid-header .k-header.date-col,
#product-prod-grid td.date-col,
#product-prod-grid td.date-cell {
  min-width: 140px !important;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
}

</style>
<style scoped>


 #product-prod-grid .k-grid-header .k-header.product-name-col,
 #product-prod-grid td.product-name-cell {
  min-width: 240px;
  overflow: hidden;
  box-sizing: border-box;
 }
#product-prod-grid .k-grid-header .product-id-col,
#product-prod-grid td.product-id-cell {
  min-width: 90px;
  box-sizing: border-box;
}
#product-prod-grid .k-grid-header .complete-rate-col,
#product-prod-grid td.complete-rate-cell {
  min-width: 100px;
  white-space: nowrap;
  box-sizing: border-box;
}
#product-prod-grid .k-grid-header .featured-col,
#product-prod-grid td.featured-cell {
  min-width: 160px;
  overflow: hidden;
  box-sizing: border-box;
  vertical-align: middle;
}
#product-prod-grid .k-grid-header .launch-status-col,
#product-prod-grid td.launch-status-cell {
  min-width: 110px;
  box-sizing: border-box;
}
#product-prod-grid .k-grid-header .review-status-col,
#product-prod-grid td.review-status-cell {
  min-width: 140px;
  overflow: hidden;
  box-sizing: border-box;
  vertical-align: middle;
}
#product-prod-grid .k-grid-header .date-col,
#product-prod-grid td.date-cell {
  min-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  vertical-align: middle;
}

#product-prod-grid td.review-status-cell .product-review-badge {
  max-width: 100%;
  height: auto;
  min-height: 26px;
  padding: 4px 8px;
  line-height: 1.25;
  white-space: normal;
  text-align: center;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#product-prod-grid td.featured-cell .badge {
  max-width: 100%;
  box-sizing: border-box;
  white-space: normal;
  height: auto;
  min-height: 26px;
  line-height: 1.25;
  text-align: center;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#product-prod-grid td.featured-cell .badge > div {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#product-prod-grid .badge{
    white-space: break-spaces;
}
.Goto-ProductDetail {
    cursor: pointer;
    display: block;
    min-width: 0;
    max-width: 100%;
    letter-spacing: normal;
}

.product-name-row {
    gap: 0.5rem;
    min-width: 0;
    width: 100%;
}

.textlengthdrop {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    word-break: break-all;
}

.textlengthdrop-img {

    margin: 0px 2px 2px 0px;
}

.edit-badge {
    flex: 0 0 auto;
    padding-inline: 0.375rem;
    border-radius: 0.25rem;
    border: 1px solid #F2F3F5;
    background-color: #ffffff;
}

.product-list-draft-pill {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 6px;
    border-radius: 4px;
    background: #ffd02c;
    color: rgba(0, 0, 0, 0.8);
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.154px;
    white-space: nowrap;
}

.product-list-draft-pill__icon {
    flex-shrink: 0;
    display: block;
    width: 14px;
    height: 16px;
}

.k-grid-toolbar {
    display: none;
}

.ButtomTop {
    margin-top: 30px;
}
.product-image-conver{
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    position: relative;
    overflow: hidden;
    border-radius: 4px;
    border: 1px rgba(0, 0, 0, 0.10) solid;
    align-items: center;
    justify-content: center;
    display: flex;
}

/* Figma 1569:244626 — Featured / Products Status / Review Status pills */
.product-launch-badge,
.product-review-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    box-sizing: border-box;
    height: 26px;
    padding: 0 8px;
    border-radius: 8px;
    font-size: 12px !important;
    font-weight: 600;
    line-height: 10px;
    white-space: nowrap;
}

#product-prod-grid td .badge.fontcolor {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    box-sizing: border-box;
    min-height: 26px;
    height: auto;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 12px !important;
    font-weight: 600;
    line-height: 1.25;
    margin: 0;
    max-width: 100%;
    white-space: normal;
}

.product-id-cell {
    color: rgba(0, 0, 0, 0.80);
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
}

.product-launch-badge {
    background: rgba(0, 255, 0, 0.25);
    color: #51BB25;
}
.product-launch-badge.is-offline{
color: rgba(0, 0, 0, 0.60);
background: rgba(0, 0, 0, 0.05);
}
.product-launch-badge__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #9e9e9e;
    flex-shrink: 0;
}

.product-launch-badge.is-online .product-launch-badge__dot {
    background: #51bb25;
}

.product-review-badge.is-not-submitted {
    background: #ffd02c;
    color: #000;
}

.product-review-badge.is-syncing {
    background: #2c6ecb;
    color: #fff;
}

.product-review-badge.is-manual {
    background: #f0ad4e;
    color: #000;
}

.product-review-badge.is-activated {
    background: #51bb25;
    color: #fff;
}

.product-review-badge.is-rejected {
    background: #cd1515;
    color: #fff;
}

.product-review-badge.is-delisted {
    background: #7a7a7a;
    color: #fff;
}

.product-bulk-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 28px;
    margin: 0;
    white-space: nowrap;
}

.product-bulk-bar__count {
    font-size: 14px;
    font-weight: 600;
    color: #1f1f1f;
}

.product-bulk-bar__delist,
.product-bulk-bar__delete {
    height: 32px;
    padding: 0 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}

.product-bulk-bar__delist {
    background: #fff;
    color: #1f1f1f;
    border: 1px solid #d9d9d9;
}

.product-bulk-bar__delete {
    background: #e53935;
    color: #fff;
    border: 1px solid #e53935;
}

.product-bulk-bar__delist:disabled,
.product-bulk-bar__delete:disabled {
    opacity: 0.6;
    cursor: default;
}
</style>
<style>
.k-grid-table  
{
    tr.k-master-row[role="row"] {
        cursor: pointer;

        > * {
            cursor: pointer;
        }
    }
}

/* 选中行底色：品牌紫 #7366FF（浅底，保证字可读） */
#product-prod-grid .k-grid-table tr.k-selected > td,
#product-prod-grid .k-grid-table tr.k-selected:hover > td,
#product-prod-grid .k-grid-table tr.k-selected.k-alt > td,
#product-prod-grid .k-grid-table tr.k-selected.k-alt:hover > td {
    background-color: rgba(115, 102, 255, 0.12) !important;
}

.product-bulk-modal .modal-dialog,
.product-bulk-modal__dialog {
    max-width: 480px;
    width: calc(100% - 32px);
    margin-left: auto;
    margin-right: auto;
}

.product-bulk-modal .modal-content,
.product-bulk-modal__content {
    border: 0;
    border-radius: 12px;
    overflow: hidden;
}

.product-bulk-modal .modal-dialog .modal-body,
.product-bulk-modal__body {
    padding: 24px !important;
}

.product-bulk-modal__title {
    font-size: 18px;
    font-weight: 700;
    color: #1f1f1f;
    margin-bottom: 8px;
}

.product-bulk-modal__text {
    font-size: 14px;
    line-height: 22px;
    color: #3d3d3d;
}

.product-bulk-modal__warn {
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 8px;
    background: #fff6d8;
    color: #5d5125;
    font-size: 14px;
}

.product-bulk-modal__warn-title {
    font-weight: 700;
    margin-bottom: 4px;
}

.product-bulk-modal__warn-list {
    margin: 0;
    padding-left: 18px;
    list-style: disc;
}

.product-bulk-modal__warn-list li {
    margin: 2px 0;
    font-weight: 400;
}

.product-bulk-modal__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    margin-top: 24px;
}

.product-bulk-modal__cancel {
    background: transparent;
    border: 0;
    color: rgba(0, 18, 26, 0.6);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    padding: 0 8px;
    height: 36px;
}

.product-bulk-modal__danger {
    min-width: 88px;
    height: 36px;
    padding: 0 16px;
    border: 0;
    border-radius: 6px;
    background: #dc3545;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}

.product-bulk-modal__primary {
    min-width: 88px;
    height: 36px;
    padding: 0 16px;
    border: 0;
    border-radius: 6px;
    background: #7366ff;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}

</style>